import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  myProductList: [],
};

const memberMyProductSlice = createSlice({
  name: "memberMyProduct",
  initialState,
  reducers: {
    setMyProductList: (state, action) => {
      state.myProductList = action.payload;
    },
    clearMyProductList: (state) => {
      state.myProductList = [];
    },
  },
});

export const {
  setMyProductList,
  clearMyProductList,
} = memberMyProductSlice.actions;
export default memberMyProductSlice.reducer;
